export const adminEmails = [
    'amilano@choice.aero',
    'amasciale@choice.aero',
    'masheer@choice.aero',
    'msholla@choice.aero',
    'arabadi@choice.aero',
    'mcasalinho@choice.aero',
    'kwang@choice.aero',
    'mozart@choice.aero',
    'yleong@choice.aero',
    'miorio@choice.aero',
    'evizuete@choice.aero',
    'messages@choice.aero',
    'byron@choice.aero',
    'mgallo@choice.aero',
    'dsegura@choice.aero',
    'lantico@choice.aero', //director of training
    'desposito@choice.aero',
    'rlimone@choice.aero',
    'vvieira@choice.aero',
    'coliveira@choice.aero',
    'solutions@choice.aero'
];

export const restrictedEmails = [
    'byron@choice.aero',
    'mozart@choice.aero',
    'frank@choice.aero',
    'iqra@choice.aero'
]